import { IntegrationType } from 'generated/generated-graphql'

export const LOCAL_STORAGE_KEY_AUTHORIZE_PARAMS = 'authorize_params'

export type CompanyAddressRegion = {
  region: string
  regionCode: string
  regionId: number
}

export type CompanyAddress = {
  id: string
  firstname: string
  lastname: string
  street: string[]
  city: string
  region: CompanyAddressRegion
  postcode: string
  telephone: string
  defaultShipping: boolean
  defaultBilling: boolean
}

export type ExternalAuthorizationParams = {
  token: string
  redirect_uri: string
  integrationType: IntegrationType
  expireTime: number
  userEmail: string
  companyType: string
  companyName: string
  companyABN?: string
  userPhone?: string
  userName?: string
  companyAddress?: CompanyAddress
}

export const getAuthorizationParamsFromLocalStorage = () => {
  const authorizationParams = localStorage.getItem(
    LOCAL_STORAGE_KEY_AUTHORIZE_PARAMS
  )
  if (!authorizationParams) {
    return null
  }
  const response = JSON.parse(
    authorizationParams
  ) as ExternalAuthorizationParams

  if (new Date(response.expireTime) < new Date()) {
    localStorage.removeItem(LOCAL_STORAGE_KEY_AUTHORIZE_PARAMS)
    return null
  }

  return response satisfies ExternalAuthorizationParams
}
